/* global BlobBuilder */
import FileType from './FileType';
import { getFileType } from './check-file-type/checkFileFormat';
// var FileType=null;
export function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString });
}

export function fileURIToBlob(uri, onLoad) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', uri, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (this.status === 200) {
      var blob = this.response;
      onLoad(blob);
    }
  };
  xhr.send();
}

export const uriToBlob = (uri) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', uri, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (this.status === 200) {
        return resolve(this.response);
      }
      return reject();
    };
    xhr.send();
  });

export const getBlob = async (url) => {
  const response = await fetch(url);
  return response.blob();
};

let hasBlobConstructor =
  typeof Blob !== 'undefined' &&
  (function () {
    try {
      return Boolean(new Blob());
    } catch (e) {
      return false;
    }
  })();

let hasArrayBufferViewSupport =
  hasBlobConstructor &&
  typeof Uint8Array !== 'undefined' &&
  (function () {
    try {
      return new Blob([new Uint8Array(100)]).size === 100;
    } catch (e) {
      return false;
    }
  })();

let hasToBlobSupport =
  typeof HTMLCanvasElement !== 'undefined'
    ? HTMLCanvasElement.prototype.toBlob
    : false;

let hasBlobSupport =
  hasToBlobSupport ||
  (typeof Uint8Array !== 'undefined' &&
    typeof ArrayBuffer !== 'undefined' &&
    typeof atob !== 'undefined');

let hasReaderSupport =
  typeof FileReader !== 'undefined' || typeof URL !== 'undefined';

export default class ImageTools {
  static resize(file, maxDimensions, callback) {
    if (typeof maxDimensions === 'function') {
      callback = maxDimensions;
      maxDimensions = {
        width: 640,
        height: 480,
      };
    }

    if (!ImageTools.isSupported() || !file.type.match(/image.*/)) {
      callback(file, false);
      return false;
    }

    if (file.type.match(/image\/gif/)) {
      // Not attempting, could be an animated gif
      callback(file, false);
      // TODO: use https://github.com/antimatter15/whammy to convert gif to webm
      return false;
    }

    let image = document.createElement('img');

    image.onload = () => {
      let width = image.width;
      let height = image.height;
      let isTooLarge = false;

      if (width > height && width > maxDimensions.width) {
        // width is the largest dimension, and it's too big.
        height *= maxDimensions.width / width;
        width = maxDimensions.width;
        isTooLarge = true;
      } else if (height > maxDimensions.height) {
        // either width wasn't over-size or height is the largest dimension
        // and the height is over-size
        width *= maxDimensions.height / height;
        height = maxDimensions.height;
        isTooLarge = true;
      }

      if (!isTooLarge) {
        // early exit; no need to resize
        callback(file, false);
        return;
      }

      let canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      let ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, width, height);

      if (hasToBlobSupport) {
        canvas.toBlob((blob) => {
          callback(blob, true);
        }, file.type);
      } else {
        let blob = ImageTools._toBlob(canvas, file.type);
        callback(blob, true);
      }
    };
    ImageTools._loadImage(image, file);

    return true;
  }

  static _toBlob(canvas, type) {
    let dataURI = canvas.toDataURL(type);
    let dataURIParts = dataURI.split(',');
    let byteString;
    if (dataURIParts[0].indexOf('base64') >= 0) {
      // Convert base64 to raw binary data held in a string:
      byteString = atob(dataURIParts[1]);
    } else {
      // Convert base64/URLEncoded data component to raw binary data:
      byteString = decodeURIComponent(dataURIParts[1]);
    }
    let arrayBuffer = new ArrayBuffer(byteString.length);
    let intArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i += 1) {
      intArray[i] = byteString.charCodeAt(i);
    }

    let mimeString = dataURIParts[0].split(':')[1].split(';')[0];
    let blob = null;

    if (hasBlobConstructor) {
      blob = new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
        type: mimeString,
      });
    } else {
      let bb = new BlobBuilder();
      bb.append(arrayBuffer);
      blob = bb.getBlob(mimeString);
    }

    return blob;
  }

  static _loadImage(image, file, callback) {
    if (typeof URL === 'undefined') {
      let reader = new FileReader();
      reader.onload = function (evt) {
        image.src = evt.target.result;
        if (callback) {
          callback();
        }
      };
      reader.readAsDataURL(file);
    } else {
      image.src = URL.createObjectURL(file);
      if (callback) {
        callback();
      }
    }
  }

  static isSupported() {
    return (
      typeof HTMLCanvasElement !== 'undefined' &&
      hasBlobSupport &&
      hasReaderSupport
    );
  }
}

export function detectFileType(fileReader, file) {
  var fileType = (FileType(new Uint8Array(fileReader.result)) || {}).ext;
  var extension = file.name.split('.');
  if (extension.length > 1) {
    extension = extension[extension.length - 1];
  } else {
    extension = null;
  }
  switch (fileType) {
    case undefined:
    case null:
      return extension;
    case 'zip':
      return getFileType(extension);
    default:
      return fileType;
  }
}
export function analyseFileType(fileType) {
  function Type(isPhoto, type) {
    return { isPhoto, type };
  }
  switch (fileType) {
    case undefined:
    case null:
      return Type(false, 'unknown');
    case 'txt':
      return Type(false, 'text');
    case 'word':
    case 'epub':
    case 'rtf':
      return Type(false, 'word');
    case 'pdf':
      return Type(false, 'pdf');
    case 'png':
    case 'jpeg':
    case 'jpg':
    case 'bmp':
    case 'gif':
    case 'webp':
    case 'ttf':
      return Type(true, 'photo');
    case 'zip':
    case 'gz':
    case 'bz2':
    case 'tar':
    case '7z':
    case 'rar':
      return Type(false, 'zip');
    case 'mp3':
    case 'wav':
    case 'm4a':
    case 'wma':
    case 'ogg':
    case 'amr':
      return Type(false, 'audio');
    case 'mp4':
    case 'mov':
    case 'm4v':
    case 'mkv':
    case 'webm':
    case 'mpg':
    case 'flv':
    case 'wmv':
    case 'avi':
      return Type(false, 'video');
    default:
      return Type(false, 'unknown');
  }
}

export function isDataURL(s) {
  return !!s.match(isDataURL.regex);
}
isDataURL.regex =
  /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;

export function isBlob(s) {
  return s.startsWith('blob:');
}
